export { default } from './Tabs';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Tabs/index.js
// module id = 188
// module chunks = 0